import { AddCircleOutline } from '@mui/icons-material';

export const Add = () => <AddCircleOutline fontSize="medium" />;
